import store from 'store2';
import { LocalStorageKey } from '../enums';
import { deleteCookieForSession } from './clientStorage';
const deleteAuthToken = () => {
    store.local.remove(LocalStorageKey.AUTH_TOKEN);
};
const removeAutoLogoutTimestamp = () => {
    store.local.remove(LocalStorageKey.COUNTDOWN_TIMESTAMP);
};
const storeAuthConfigDone = (value) => {
    store.local.set(LocalStorageKey.AUTH_CONFIG_DONE, value);
};
const cleanUpAuthData = () => {
    deleteCookieForSession();
    removeAutoLogoutTimestamp();
    deleteAuthToken();
    storeAuthConfigDone(false);
    store.local.remove(LocalStorageKey.AUTH_TIME_DIFF);
};
export const cleanUpSessionData = () => {
    cleanUpAuthData();
    [
        '/transaction_account',
        '/customer',
        '/customer/product/access',
        '/branding',
        '/deposits/types',
        '/threads/unread-count',
        '/accounts',
        '/pension/customer/products',
        '/products',
        '/product_instances',
        ...store.keys().filter((item) => item.includes('/accounts/TRA')),
        ...store.keys().filter((item) => item.includes('/customers/')),
    ].forEach((item) => {
        store.local.remove(item || '');
    });
};
//# sourceMappingURL=sessionCleanup.js.map